<template>
	<div class="label-input choice">
		<input
			v-bind="inputAttrs"
			type="radio"
			class="mradio"
			@change="$emit('input', value)"
			:id="id"
			:name="name"
			:checked="checked"
			:value="value"
			:disabled="disabled"
		/>
		<label :for="id"> {{ label }}<span class="icon-radio"></span></label>
		<m-tooltip v-if="helpText" :text="helpText" :raw="true" />
	</div>
</template>

<script>
import MTooltip from './MTooltip';

export default {
	name: 'MChoice',
	components: { MTooltip },
	props: {
		name: {
			type: String,
			required: false,
			default: 'false'
		},
		value: {
			type: String,
			required: false,
			default: null
		},
		id: {
			type: String,
			required: true
		},
		label: {
			type: String,
			required: false,
			default: ''
		},
		checked: {
			type: Boolean,
			required: false,
			default: false
		},
		inputAttrs: {
			type: Object,
			required: false,
			default() {
				return {}
			}
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false
		},
		helpText: {
			type: String,
			required: false
		}
	}
}
</script>

<style scoped></style>
